import Locales from '../../assets/const/locales';

export default {
    [Locales.ENGLISH]: {
        productsTitle: 'Products',
        rateplansTitle: 'Rateplans',
        articlesTitle: 'Articles',
        supportTitle: 'Support',
        searchResultsFor: 'Search Results for',
        learnMore: 'Learn More',
        perPage12: '12 per page',
        perPage24: '24 per page',
        perPage48: '48 per page',
        mostRelevant: 'Relevant',
        alphabeticalAsc: 'Alphabetical - Ascending',
        alphabeticalDesc: 'Alphabetical - Descending',
        priceAsc: 'Price - Ascending',
        priceDesc: 'Price - Descending',
        withRateplan: 'WITH RATEPLAN',
        initialPrice: 'Initial Price',
        finalPrice: 'Final Price',
        freePrice: 'Free',
        monthlyPay: 'Monthly Pay',
        comingSoon: "Preorder",
        compare: "Compare"
    },
    [Locales.GREEK]: {
        productsTitle: 'Προϊόντα',
        rateplansTitle: 'Προγράμματα',
        articlesTitle: 'Άρθρα',
        supportTitle: 'Υποστήριξη',
        searchResultsFor: 'Αποτελέσματα αναζήτησης για',
        learnMore: 'Μάθε Περισσότερα',
        perPage12: '12 ανά σελίδα',
        perPage24: '24 ανά σελίδα',
        perPage48: '48 ανά σελίδα',
        mostRelevant: 'Συνάφεια',
        alphabeticalAsc: 'Αλφαβητικά - Αύξουσα',
        alphabeticalDesc: 'Αλφαβητικά - Φθίνουσα',
        priceAsc: 'Τιμή - Αύξουσα',
        priceDesc: 'Τιμή - Φθίνουσα',
        withRateplan: 'ΜΕ ΠΡΟΓΡΑΜΜΑ',
        initialPrice: 'Αρχική Τιμή',
        finalPrice: 'Τελική Τιμή',
        freePrice: 'Δωρεάν',
        monthlyPay: 'ΜΗΝΙΑΙΟ ΠΑΓΙΟ',
        comingSoon: "Προπαραγγελία",
        compare: "Σύγκρινε"
    },
};